import { call } from '../@';
import { IFindAddressByPostcodeResponse } from './epc-types';

export default async function findAddressByPostcode(postcode: string): Promise<IFindAddressByPostcodeResponse[]> {
	return await call('epc-findAddressByPostcode', { postcode });
}
